import { LineChart, LayoutGrid, Coins, ChartBar } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <ChartBar className="h-8 w-8 text-white" />,
      title: "Trayectoria",
      descriptionDesktop:
        "Casos de éxito comprobados en el sector industrial que avalan nuestra experiencia y capacidad para ofrecer resultados reales y sostenibles.",
      descriptionMobile:
        "Experiencia real con industrias que ya reducen costos energéticos.",
    },
    {
      icon: <LayoutGrid className="h-8 w-8 text-white" />,
      title: "Flexibilidad",
      descriptionDesktop:
        "Nos adaptamos a las necesidades de cada empresa con soluciones técnicas personalizadas y enfoque estratégico.",
      descriptionMobile:
        "Nos adaptamos a tu operación para obtener resultados rápidos.",
    },
    {
      icon: <LineChart className="h-8 w-8 text-white" />,
      title: "Mejora continua",
      descriptionDesktop:
        "Actualizamos constantemente nuestros procesos y herramientas para garantizar eficiencia y precisión en cada servicio.",
      descriptionMobile:
        "Siempre optimizando procesos y herramientas.",
    },
    {
      icon: <Coins className="h-8 w-8 text-white" />,
      title: "Rentabilidad",
      descriptionDesktop:
        "Reducimos costos y optimizamos recursos para lograr el máximo retorno de inversión sin comprometer la productividad.",
      descriptionMobile:
        "Ahorro real sin afectar tu productividad.",
    },
  ];

  return (
    <section className="relative bg-white py-32 overflow-hidden">
      {/* Fondo sutil */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(0,0,0,0.03)_0%,_transparent_80%)]"></div>

      <div className="container mx-auto px-6 relative z-10">
        
        {/* Encabezado */}
        <AnimatedSection className="text-center mb-20">
          
          {/* Título MOBILE */}
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4 block md:hidden">
            Soluciones rápidas y efectivas para mejorar tu energía
          </h2>

          {/* Título DESKTOP */}
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4 hidden md:block">
            Eficiencia, experiencia y resultados que generan confianza
          </h2>

          {/* Descripción MOBILE */}
          <p className="text-base text-gray-700 max-w-2xl mx-auto block md:hidden">
            Acompañamos a tu operación con mejoras medibles y estrategias que reducen costos desde el primer mes.
          </p>

          {/* Descripción DESKTOP */}
          <p className="text-lg text-gray-700 max-w-3xl mx-auto hidden md:block">
            Optimizamos la gestión energética de las industrias con soluciones confiables, medibles y adaptadas a cada operación.
          </p>

        </AnimatedSection>

        {/* Cards */}
        <div className="relative flex flex-wrap justify-center gap-8 pb-32">
          {reasons.map((reason, index) => (
            <AnimatedSection
              key={index}
              className={`
                group w-full sm:w-[45%] lg:w-[22%]
                bg-white rounded-2xl p-8 shadow-[0_4px_20px_rgba(0,0,0,0.05)]
                hover:shadow-[0_8px_30px_rgba(0,0,0,0.1)]
                hover:-translate-y-3 transition-all duration-500
                ${index % 2 === 0 ? "translate-y-6" : "-translate-y-6"}
              `}
            >
              {/* Icono */}
              <div className="mb-6 flex justify-center">
                <div className="h-16 w-16 rounded-full bg-gradient-to-br from-[#f4b24c] to-[#c56a00] flex items-center justify-center shadow-[0_6px_18px_rgba(244,178,76,0.4)] group-hover:scale-110 transition-transform duration-500">
                  {reason.icon}
                </div>
              </div>

              <h3 className="text-2xl font-bold text-[#c56a00] mb-4 text-center group-hover:text-[#9c5200] transition-colors duration-300">
                {reason.title}
              </h3>

              {/* Descripción MOBILE */}
              <p className="text-gray-700 text-center leading-relaxed block md:hidden">
                {reason.descriptionMobile}
              </p>

              {/* Descripción DESKTOP */}
              <p className="text-gray-700 text-center leading-relaxed hidden md:block">
                {reason.descriptionDesktop}
              </p>

              {/* Línea decorativa */}
              <div className="mt-6 mx-auto w-12 h-1 bg-[#f4b24c] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </AnimatedSection>
          ))}

          {/* Suelo */}
          <div
            className="absolute -bottom-20 left-1/2 -translate-x-1/2 w-[95%] h-[8px]
              bg-gradient-to-r from-transparent via-[#d6d6d6] to-transparent
              shadow-[0_-4px_12px_rgba(0,0,0,0.15)]
              rounded-full blur-[2px]"
          ></div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
